// ابزارهای کد ملی (هم‌خوان با بک‌اند)

const PERSIAN = '۰۱۲۳۴۵۶۷۸۹';
const ARABIC = '٠١٢٣٤٥٦٧٨٩';

export function toLatinDigits(value) {
  return String(value ?? '')
    .replace(/[۰-۹]/g, (d) => String(PERSIAN.indexOf(d)))
    .replace(/[٠-٩]/g, (d) => String(ARABIC.indexOf(d)));
}

/** فقط ارقام لاتین، حداکثر ۱۰ رقم */
export function sanitizeNationalCode(value) {
  return toLatinDigits(value).replace(/\D/g, '').slice(0, 10);
}

export function isValidNationalCode(value) {
  const code = sanitizeNationalCode(value);
  if (code.length !== 10) return false;
  if (/^(\d)\1{9}$/.test(code)) return false;

  const check = Number(code[9]);
  let sum = 0;
  for (let i = 0; i < 9; i += 1) sum += Number(code[i]) * (10 - i);
  const rem = sum % 11;

  return rem < 2 ? check === rem : check === 11 - rem;
}

/** پیام خطای فارسی برای کد ملی (یا رشته‌ی خالی اگر معتبر است) */
export function getNationalCodeError(value) {
  const code = sanitizeNationalCode(value);
  if (!code) return 'کد ملی الزامی است';
  if (code.length !== 10) return 'کد ملی باید دقیقاً ۱۰ رقم باشد';
  if (!isValidNationalCode(code)) return 'کد ملی وارد‌شده معتبر نیست';
  return '';
}
